import { ITenant, LoanOption } from "@oneethos/shared"
import { useAppState } from "../hooks"
import { SubformProps } from "../pages/consumerApplicationForm"
import LoanOptions from "./loan-options"

type ProductSelectionProps = Partial<SubformProps> & {
  loanOptions: LoanOption[]
}

export const ProductSelection = ({
  formData,
  update,
  loanOptions
}: ProductSelectionProps) => {
  const { tenant } = useAppState()

  const handleProductSelect = async (product) => {
    update({
      ...formData,
      productId: product.id,
      loanDurationMonths: product.term,
      interest: product.interestRateWithAutopay
    })
  }

  return <div>
    <LoanOptions
      financingTenant={tenant.config as ITenant}
      formData={formData}
      loanOptions={loanOptions}
      onProductSelect={handleProductSelect}
      isConsumerView
      maxPaymentAmount={formData.maxAllowableMonthlyPayment}
    />
  </div>
}
